<template>
  <section class="sm-account__main">
    <div class="sm-wrap">
      <div class="sm-account__main-inner">
        <tabs-elem :tabs="tabs" :type="'links'" :scroll="true" />

        <components :is='currentTab' :userPlanProp="customerPlan" :userAccountProp="customerAccount"
          @callMethod="callMethod" @plan="popup.isOpen = true" />
      </div>
    </div>

    <popup-block v-if="popup.isOpen" :open="popup.isOpen" :size="'medium'" :class="'sm-account__main-popup'"
      @close="popup.isOpen = false">
      <template slot="popupContent">
        <activate-customer :item="customerAccount" :coupons="coupons" :plans="plans" @cancel="popup.isOpen = false"
          @activate="activateCustomer" />
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Tabs from '@/components/Tabs';
import Popup from '@/components/Popup';
import DropdownWrap from '@/components/DropdownWrap';
import Spinner from '@/components/Spinner';
import { CheckHigherRole } from '@/utils/roles';
import { FormatPrice } from '@/utils/general-data';
import Periods from '@/settings/periods';
import ActivateCustomer from '@/components/customers/ActivateCustomer';

export default {
  name: 'customer-main',
  components: {
    'account': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Account'),
    'extras': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Extras'),
    'phone': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Phone'),
    'live-answering': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/LiveAnswering'),
    'forwarding': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Forwarding'),
    'activity': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Activity'),
    'events': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Events'),
    'plans_and_billing': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/PlansAndBilling'),
    'mail': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/customer/components/Mail'),

    'tabs-elem': Tabs,
    'popup-block': Popup,
    'dropdown-wrap': DropdownWrap,
    'sm-spinner': Spinner,
    'activate-customer': ActivateCustomer
  },
  data() {
    return {
      allTabs: [
        {
          tab: 'account',
          text: 'Account',
        },
        {
          tab: 'forwarding',
          text: 'Addresses',
          // plan_field: 'has_mail_forwarding'
        },
        {
          tab: 'mail',
          text: 'Mail',
          plan_field: 'mail_service_enabled',
          disabledInAdmin: true
        },
        {
          tab: 'extras',
          text: 'Additional Services',
          disabledInAdmin: true,
          levels: [2, 3]
        },
        {
          tab: 'phone',
          text: 'Virtual Phone Number',
          plan_field: 'phone_service_enabled',
          disabledInAdmin: true,
          levels: [2, 3],
          except: ['mail_admin']
        },
        {
          tab: 'live-answering',
          text: 'Live Answering',
          plan_field: 'phone_service_enabled',
          disabledInAdmin: true,
          levels: [2, 3],
          except: ['mail_admin']
        },
        {
          tab: 'activity',
          text: 'Activity',
          disabledInAdmin: true,
          levels: [2, 3]
        },
        {
          tab: 'plans_and_billing',
          text: 'Plans & Billing',
          // disabledInAdmin: true,
          levels: [2, 3],
          except: ['mail_admin']
        },
        {
          tab: 'events',
          text: 'History',
          except: ['mail_admin']
          // disabledInAdmin: true,
        },
      ],
      customerPlan: {},

      plans: [],
      coupons: [],
      periodAlts: Periods.alts,
      popup: {
        isOpen: false
      },
      showSpinner: false
    }
  },
  created() {

    if (this.customerAccount.plan_id)
      this.getPlan(this.customerAccount.plan_id)
        .then(res => {
          this.customerPlan = res;
        });

    Promise.all([
      this.getPlans(true),
      this.getCoupons()
    ])
      .then(([plans, coupons]) => {
        this.plans = [];

        plans.forEach(plan => {
          this.plans.push({
            id: plan.id,
            name: `${plan.title} - ${this.formatPrice(plan.period_amount)}/${this.periodAlts[plan.period_unit]}${!plan.is_active ? ' (Hidden)' : ''}`,
            setup_fee: plan.setup_fee,
            term: plan.period_unit
          });

          this.plans.push({
            id: plan.id,
            name: `${plan.title} - ${this.formatPrice(plan.subscription_price)}/month${!plan.is_active ? ' (Hidden)' : ''}`,
            setup_fee: plan.setup_fee,
            term: 'monthly'
          });
        });

        this.coupons = coupons;
      })
      .catch(e => {
        console.log(e, e.response);
      });
  },
  computed: {
    ...mapGetters({
      customerAccount: 'customers/currentCustomer',
      userAccount: 'account/userAccount',
      provider: 'provider'
    }),
    tabs() {
      if (this.customerAccount.plan_id && !Object.keys(this.customerPlan).length)
        return this.allTabs;
      let role = this.userAccount.role;
      let type = this.customerAccount.type;
      return this.allTabs.filter(tab => {
        if (type == "AdditionalRecipient" && tab.tab!="account"){
          return false;
        }
        if (role && tab.except && tab.except.includes(role)) {
          return false;
        }
        if (
          this.customerAccount.role != 'subscriber' &&
          this.customerAccount.role != 'mail_admin' &&
          tab.disabledInAdmin
        )
          return false;

        if (tab.levels && !tab.levels.includes(this.provider.client_level))
          return false;

        // if (
        //   tab.hasOwnProperty('plan_field') && 
        //   this.customerPlan.hasOwnProperty(tab.plan_field) && 
        //   !this.customerPlan[tab.plan_field]
        // )
        //   return false;

        return true;
      });
    },
    currentTab() {
      let query = this.$route.query;

      if (query.tab) {
        let newTab = this.tabs.find(item => item.tab == query.tab);

        return newTab ? newTab.tab : this.tabs[0].tab;
      } else {
        return this.tabs[0].tab;
      }
    }
  },
  methods: {
    ...mapActions({
      getPlan: 'plans/getPlan',
      getPlans: 'plans/getPlans',
      getCoupons: 'billing/getCoupons',
      getCustomer: 'customers/getCustomer',
      enableCustomer: 'customers/enableCustomer',
    }),
    formatPrice: FormatPrice,
    callMethod(method, callback, err, ...params) {
      if (!this[method])
        return false;

      this[method](...params)
        .then((res) => callback(res))
        .catch(e => err(e));
    },
    activateCustomer(data) {
      this.showSpinner = true;
      this.enableCustomer(data)
        .then(res => {
          this.getCustomer(this.customerAccount.id)
            .then(res => {
              this.showSpinner = false;
              this.popup.isOpen = false;
            });
        });
    }
  },
  watch: {
    customerAccount: {
      deep: true,
      handler(val) {
        if (val.plan_id)
          this.getPlan(val.plan_id)
            .then(res => {
              this.customerPlan = res;
            });
      }
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;

.sm-account__main {
  position: relative;

  &-inner {
    position: relative;
    margin: 34px 0 150px;

    &>.sm-tabs {
      margin-bottom: 30px;

      &>.sm-tabs__item {
        margin-right: 30px;

        @include media('<large') {
          margin-right: 16px;
        }
      }
    }
  }

  &-popup {
    & .sm-dropdown-wrap {
      margin-top: 12px
    }

    &-flex {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;

      &>* {
        width: calc(50% - 10px);
      }
    }
  }
}
</style>
